import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootReducerState } from 'types/global';
import { NotificationReducer } from 'types/notification';
import { FormLondonProtocolV1 } from './FormV1';
import { FormLondonProtocolV2 } from './FormV2';
import { FormLondonProtocolV3 } from './FormV3';

const FormLondonVersioned: React.FC = () => {
    const notificationSelector: NotificationReducer = useSelector((state: RootReducerState) => state.notificationsReducer)
    const version = useMemo(() => notificationSelector?.notificationById?.u_version?.value, [notificationSelector?.notificationById])
    switch (version) {
        case 'v1':
            return <FormLondonProtocolV1 />
        case 'v2':
            return <FormLondonProtocolV2 />
        case 'v3':
            return <FormLondonProtocolV3 />

        default:
            return <FormLondonProtocolV3 />
    }
}

export default FormLondonVersioned